import { Typography, useTheme } from '@material-ui/core';

import SearchIcon from '@mui/icons-material/Search';
import { FontFamily } from '@principal-developer-portal/ui';

export const EmptyTermComponent = () => {
  const theme = useTheme();
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px 0px 20px 0px',
      }}
    >
      <SearchIcon
        style={{ fontSize: '120px' }}
        htmlColor={theme.palette.grey[600]}
      />
      <div>
        <Typography
          variant="h4"
          style={{
            fontFamily: FontFamily.Bold,
            color: theme.palette.grey[600],
            paddingLeft: '8px',
          }}
        >
          Please enter a search term to begin.
        </Typography>
      </div>
    </div>
  );
};
